// store/features/email-templates.feature.tsx
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../base-query';
import {
  EmailTemplate,
  CreateEmailTemplateRequest,
  EditEmailTemplateRequest,
  EmailTemplateListResponse,
} from '@/types';

export const emailTemplatesApi = createApi({
  reducerPath: 'emailTemplatesApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['EmailTemplate'],
  endpoints: (builder) => ({
    listEmailTemplates: builder.query<
      EmailTemplateListResponse,
      Record<string, never>
    >({
      query: () => '/ai/email-templates',
      providesTags: ['EmailTemplate'],
    }),

    getEmailTemplate: builder.query<EmailTemplate, string>({
      query: (templateId) => `/ai/email-templates/${templateId}`,
      providesTags: (_, __, id) => [{ type: 'EmailTemplate', id }],
    }),

    createEmailTemplate: builder.mutation<
      EmailTemplate,
      CreateEmailTemplateRequest
    >({
      query: (body) => ({
        url: '/ai/email-templates',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['EmailTemplate'],
    }),

    updateEmailTemplate: builder.mutation<
      EmailTemplate,
      { templateId: string; data: EditEmailTemplateRequest }
    >({
      query: ({ templateId, data }) => ({
        url: `/ai/email-templates/${templateId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (_, __, { templateId }) => [
        'EmailTemplate',
        { type: 'EmailTemplate', id: templateId },
      ],
    }),

    deleteEmailTemplate: builder.mutation<{ message: string }, string>({
      query: (templateId) => ({
        url: `/ai/email-templates/${templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailTemplate'],
    }),
  }),
});

export const {
  useListEmailTemplatesQuery,
  useCreateEmailTemplateMutation,
  useUpdateEmailTemplateMutation,
  useDeleteEmailTemplateMutation,
} = emailTemplatesApi;
